import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";

/* images */
import imgPilates from "../../assets/images/services/pilates.jpg";
import imgCircuit from "../../assets/images/services/circuit.jpg";
import imgTrx from "../../assets/images/services/trx.jpg";
import imgBodyshape from "../../assets/images/services/bodyshape.jpg";
import imgStretch from "../../assets/images/services/pilates.jpg";
import imgFunctional from "../../assets/images/services/functional.jpg";
import imgPersonal from "../../assets/images/services/personal.jpg";

/**
 * ServicesShort — simple 3‑card grid for the home page.
 *
 * • Displays exactly three services side‑by‑side (stacks on < md).
 * • Each card = image + service name. No descriptions, no alternating stripes.
 * • Optional headline + CTA button kept for consistency.
 * • Re‑uses existing .glassPane + .stripeImg styles → no new CSS needed.
 */
export default function ServicesShort({
    data,
    title,
    ctaPath = "/szolgaltatasok",
    ctaLabel,
    motionOrder = 0,
}) {
    const t = useTranslation();

    // default service list — identical to long component
    const fullServices = [
        { img: imgPilates, key: "pilates" },
        { img: imgCircuit, key: "koredzes" },
        { img: imgTrx, key: "trx" },
        { img: imgBodyshape, key: "alakformalo" },
        { img: imgStretch, key: "mobilitas" },
        { img: imgFunctional, key: "funkcionalis" },
        { img: imgPersonal, key: "szemelyiedzes" },
    ];

    const services = (data || fullServices).slice(0, 3);

    // animation helper
    const fadeUp = i => ({
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { delay: (motionOrder + i) * 0.05, duration: 0.4 },
        },
    });

    // UI text fallbacks
    const headline = t("home.services.title");
    const buttonLabel = t("home.services.viewFull");

    return (
        <section id="servicesShort" >{/* reuse dark wrapper for bg */}
            <motion.div
                className="text-center"
                variants={fadeUp(0)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-50px" }}
            >

                <Container className="servicesShortContainer">
                    {/* Headline + CTA */}
                    <div className="glass-wrapper shadow text-center">
                        <h3 className="servicesShortTitle mb-5 mt-4">{headline}</h3>

                        {/* 3‑card grid */}

                        <Row className="servicesShortRow">
                            {services.map(({ img, key }, idx) => (
                                <Col key={key} xl={4} md={6} sm={12} className="d-flex ">
                                    <NavLink to={ctaPath + "/#" + key}>
                                        <motion.div
                                            className="glassPaneShort w-100 p-0 d-flex flex-column"
                                            variants={fadeUp(idx + 1)}
                                            initial="hidden"
                                            whileInView="show"
                                            viewport={{ once: true, margin: "-50px" }}
                                            whileHover={{ scale: 1.04 }}
                                            transition={{ duration: 0.35, ease: "easeInOut" }}
                                        >
                                            <div className="glassPaneShortWrapper">
                                                <h4 className="stripeName text-center">
                                                    {t(`services.${key}.name`)}
                                                </h4>
                                                <Image
                                                    src={img}
                                                    alt={t(`services.${key}.name`)}
                                                    className="stripeImgShort"
                                                    fluid
                                                    width={800}
                                                    height={850}
                                                />
                                            </div>
                                        </motion.div>
                                    </NavLink>
                                </Col>
                            ))}
                        </Row>
                        <div className="text-center mt-4 mb-4">
                            <NavLink to={ctaPath} className="servicesShortBtn btn btn-outline-warning p-3 mt-4">
                                {buttonLabel}
                            </NavLink>
                        </div>
                    </div>
                </Container>
            </motion.div>
        </section >
    );
}
